import React, { useCallback, useEffect, useState } from 'react';
import { useTimeoutFn } from 'react-use';
import { ErrorMessage } from './ErrorMessage';
import { LoaderComponent } from './Loader';

type Props = {
  reloadFunction?: (...args: unknown[]) => unknown;
  // timeout milliseconds
  waitPeriod?: number;
  loadingStatus?: boolean;
  reduxErrorStatus?: boolean | string | object;
  // Text that accompanies the error message
  contentType?: string;
  // Adds a default height to pages with content items
  defaultHeight?: boolean;
  streamItem?: boolean;
  disableWaitPeriod?: boolean;
  className?: string;
};

export const LoaderWrapper = (props: Props) => {
  const {
    reloadFunction = () => {},
    waitPeriod = 60000,
    contentType = '',
    defaultHeight = false,
    streamItem = false,
    reduxErrorStatus = false,
    loadingStatus = true,
    disableWaitPeriod = false,
    className = '',
  } = props;
  const [loadingFailed, setLoadingFailed] = useState(false);
  const [, cancelTimeout, resetTimeout] = useTimeoutFn(() => {
    if (loadingStatus && !disableWaitPeriod) {
      setLoadingFailed(true);
    }
  }, waitPeriod);

  const checkIfLoadingFailed = useCallback(() => {
    if (loadingStatus && !disableWaitPeriod) {
      resetTimeout();
    } else {
      cancelTimeout();
    }
  }, [cancelTimeout, disableWaitPeriod, loadingStatus, resetTimeout]);

  const tryReload = () => {
    reloadFunction(); // call the function passed into from redux
    setLoadingFailed(false); // show the loader again
    checkIfLoadingFailed(); // start the timer
  };

  const displayErrorMessage = () => <ErrorMessage error={reduxErrorStatus} reload={tryReload} content={contentType} />;

  useEffect(() => {
    checkIfLoadingFailed();
    return cancelTimeout;
  }, [cancelTimeout, checkIfLoadingFailed]);

  return (
    <div className={className}>
      {loadingStatus ? (
        <div>
          {loadingFailed ? (
            displayErrorMessage()
          ) : (
            <LoaderComponent defaultHeight={defaultHeight} streamItem={streamItem} />
          )}
        </div>
      ) : (
        <div>{reduxErrorStatus && displayErrorMessage()}</div>
      )}
    </div>
  );
};
